export const DEFAULT_CONFIG = {
  model: {
  //   url: '',
    rotate: {
      x: 0,
      y: 0,
      z: 0,
    },
  },
  camera: {
    fov: 35,
    horizontalAngle: 0,
    verticalAngle: 0,
    zoom: 0, // todo: max 10 || -10
  },
  lights: {
    exposure: 1, // --> renderer.toneMappingExposure()
    intensity: 0.5,
    envMap: {
      enabled: true,
      hdr: true,
      preset: 'studio_2_sides', //'neutral',
      blur: 0,
      rotation: 0,
    },
    showFlatBackground: false,
    useHdriLightingOnly: false,
    lockHdriRotationToCamera: false,
  },
  general: {
    toneMapping: 'aces', // "none" || "linear" || "reinhard" || "cineon" || "aces" || "agx" || "neutral"
  },
  shadows: {
    enabled: false,
    horizontalAngle: 315,
    verticalAngle: 45,
    opacity: 0.5,
    color: '#000000',
  },
  postProcessing: {},
  scene: {
    walls: false,
    wallsColor: '#ffffff',
    floor: false,
    floorColor: '#ffffff',
    reflectiveFloor: false,
  },
  isAnimated: false,
  debug: {
    orbitControls: true,
    showHelpers: false,
    modelHelper: false,
    log: false,
	  showWireframe: false,
	  showModelStats: false,
	  printStructure: false,
	  printMeshDetailsOnClick: false,
    noRender: false,
  },
	video: {
		enabled: false,
		//frames-per-second
		//fps: 30,
		//seconds
		//duration: 5,
	},
  textNodes: {
    enabled: false,
    nodes: [
      {
        // Example:
        // name: "text_node_left",
        // text: "",
        
        // position: [0.295,0.143,-0.118],
        // rotation: [-81.0,85.0,63.1],
        
        // scale: [0.03, 0.03, 0.03],
        // bendFactor: 0.03,
        // textHeight:0.01,

        // color: "red",
      },
    ],
  },
};
